import loadable from '@loadable/component';

export const OrgDashboardManageListingsPageLoadable = loadable(
  () => import('./OrgDashboardManageListingsPage'),
  { resolveComponent: (module) => module.OrgDashboardManageListingsPage },
);
